var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconSupport = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.6001,
    cy: 16,
    r: 15.4074,
    fill: "#FFB1BF",
    stroke: "white",
    strokeWidth: 1.18519
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8234 22.2216L24.6952 23.0728C24.8656 23.2391 25.096 23.3272 25.3265 23.3272C25.557 23.3272 25.7825 23.244 25.9579 23.0728C26.3036 22.7353 26.3086 22.1874 25.9579 21.845L26.5391 22.4124C26.7094 22.5787 26.9399 22.6668 27.1704 22.6668C27.4009 22.6668 27.6264 22.5836 27.8017 22.4124C28.1475 22.0749 28.1475 21.5221 27.8017 21.1846L26.9299 20.3383C27.1003 20.5046 27.3307 20.5927 27.5612 20.5927C27.7917 20.5927 28.0172 20.5095 28.1926 20.3383C28.5383 20.0008 28.5383 19.448 28.1926 19.1105L24.134 15.1629H25.6873C26.1783 15.1629 26.5792 14.7764 26.5792 14.297C26.5792 13.8176 26.1783 13.4312 25.6873 13.4312C25.6873 13.4312 23.192 13.441 22.3603 13.4312C21.4033 13.4165 20.1907 13.6513 18.8629 14.9427C17.5351 16.2341 17.6253 18.6409 19.0934 20.0693L22.5657 23.4495C22.7361 23.6158 22.9666 23.7038 23.197 23.7038C23.4275 23.7038 23.653 23.6207 23.8284 23.4495C24.1741 23.1119 24.1741 22.5592 23.8284 22.2216H23.8234Z",
    stroke: "#8C2B3D",
    strokeWidth: 1.18519,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0195 20.4656L23.8233 22.2217",
    stroke: "#8C2B3D",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2773 19.2377L25.958 21.845",
    stroke: "#8C2B3D",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.54 18.0148L26.9251 20.3384",
    stroke: "#8C2B3D",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37653 22.2216L8.5047 23.0728C8.33434 23.2391 8.10386 23.3272 7.87337 23.3272C7.64289 23.3272 7.41741 23.244 7.24204 23.0728C6.89632 22.7353 6.89131 22.1874 7.24204 21.845L6.66082 22.4124C6.49046 22.5787 6.25998 22.6668 6.02949 22.6668C5.79901 22.6668 5.57353 22.5836 5.39816 22.4124C5.05244 22.0749 5.05244 21.5221 5.39816 21.1846L6.27 20.3383C6.09964 20.5046 5.86916 20.5927 5.63867 20.5927C5.40819 20.5927 5.18271 20.5095 5.00734 20.3383C4.66162 20.0008 4.66162 19.448 5.00734 19.1105L9.06588 15.1629H7.51261C7.02158 15.1629 6.62074 14.7764 6.62074 14.297C6.62074 13.8176 7.02158 13.4312 7.51261 13.4312C7.51261 13.4312 10.0079 13.441 10.8396 13.4312C11.7966 13.4165 13.0092 13.6513 14.337 14.9427C15.6648 16.2341 15.5746 18.6409 14.1065 20.0693L10.6342 23.4495C10.4638 23.6158 10.2333 23.7038 10.0029 23.7038C9.77237 23.7038 9.54689 23.6207 9.37152 23.4495C9.0258 23.1119 9.0258 22.5592 9.37152 22.2216H9.37653Z",
    stroke: "#8C2B3D",
    strokeWidth: 1.18519,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1803 20.4656L9.37646 22.2217",
    stroke: "#8C2B3D",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91782 19.2377L7.24219 21.845",
    stroke: "#8C2B3D",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65992 18.0148L6.2749 20.3384",
    stroke: "#8C2B3D",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3055 9.24608L16.7785 13.5992L20.2516 9.24608C20.2516 9.24608 20.2565 9.23655 20.2614 9.23179C20.541 8.87935 20.698 8.45546 20.7078 8.00776C20.7274 7.04093 20.0504 6.16458 19.1086 5.96931C18.0883 5.75975 17.0876 6.35509 16.7785 7.36003C16.4646 6.35509 15.4639 5.75499 14.4435 5.96931C13.5066 6.16458 12.8247 7.04093 12.8493 8.00776C12.8591 8.45546 13.0112 8.87935 13.2957 9.22703C13.2957 9.22703 13.3006 9.23655 13.3055 9.24131V9.24608Z",
    stroke: "#8C2B3D",
    strokeWidth: 1.18519,
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSupport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconSupport.2686c70a.svg";
export { ForwardRef as ReactComponent };